const namespace = "notificationToaster";

export const CASH_DESCRIPTION = `${namespace}.cashDescription`;
export const BONUS_DESCRIPTION = `${namespace}.bonusDescription`;
